import {API_DOC_META, customTitle} from "../core-web/constants";
import Link from "next/link";
import {WebsiteLayout} from "../core-web/components/landing/WebsiteLayout";
import Navigation from "../core-web/components/landing/molecules/Navigation";
import {Box} from "@chakra-ui/react";
import {PageHead} from "../core-web/components/core/templates/PageHead";
import Footer from "../core-web/components/landing/molecules/Footer";

const apiParameters = [
  {
    name: "pageUrl",
    description: "Notion page url (public)"
  },
  {
    name: "pageConfig",
    description: "Page Configuration (Object)"
  },
  {
    name: "pageConfig.hideUnsupported",
    description: "Hide unsupported blocks from rendered page. If false - placeholder is rendered"
  },
  {
    name: "pageConfig.showIcon",
    description: "Display Notion page icon on top of the title"
  }, {
    name: "pageConfig.showTitle",
    description: "Display Notion page title"
  }, {
    name: "pageConfig.alignCenter",
    description: "Center page content. Disabled when fullWidth is active"
  }, {
    name: "pageConfig.fullWidth",
    description: "Stretch content to fit the full page width."
  }

]


const ApiDoc = () => {

  return <PageHead title={customTitle("Render API documentation")}
    description={API_DOC_META}>
    <WebsiteLayout>
      <Navigation/>
      <Box minH={"75vh"} display={"flex"} alignItems={"center"}>

        <div className={"my-16 space-y-8 overflow-hidden"}>

          <h1 className={"text-4xl font-medium pb-0"}>NotionSender API</h1>
          <div className={"space-y-2"}>
            <div>The Notion Sender API lets you integrate rendering for Notion pages.</div>
            <div>You can use API without Authorization and for free if your usage is below 100 render requests
              per week
            </div>
            <div>If you utilize more than 100 renders per week - please contact me via email at <a
              className={"text-blue-500"} href={"mailto:notionsender@gmail.com"}>notionsender@gmail.com</a>
            </div>

            <div className={""}>
              Looking for the how to guide? Check
              <Link href={"/create-and-send-email-from-notion"} legacyBehavior>
                <a className={"text-blue-500 px-1"}>how to create or send email with Notion</a>
              </Link>
            </div>

          </div>
          <div className={"space-y-4"}>
            <h2 className={"text-3xl font-medium"}>Render Notion Page</h2>
            <div className={"space-x-2 py-2 font-medium"}>
              URI: <span
                className={"text-blue-500 bg-gray-100 px-2 py-2"}>https://notionsender.com/api/render</span>
            </div>

            <div className={"space-y-4"}>
              <div className={"text-2xl font-semibold"}>Arguments</div>
              <div className={"max-w-2xl"}>
                {apiParameters.map(({name, description}, index) => {
                  return <div className={"border-b border-gray-300  py-2 space-y-2"} key={index}>
                    <div className={"font-semibold"}>{name}</div>
                    <div className={""}>{description}</div>
                  </div>
                })}

              </div>
              <div className={"text-2xl font-semibold"}>Request</div>
              <div className={"text-sm bg-gray-200 pl-4 py-4 overflow-scroll max-w-3xl rounded"}>
                <code className={""}>
                  <p>POST https://api.notionsender.com/render HTTP/1.1</p>
                  <p>Content-Type: application/json</p>
                  <p>&nbsp;</p>
                  <pre>
                    {
                      JSON.stringify({
                        pageUrl: "https://email-pages.notion.site/Meeting-Notes-Template-fa51b4c638ae492188aeae3ba784d791",
                        pageConfig: {
                          hideUnsupported: true,
                          showIcon: false,
                          showTitle: true,
                          alignCenter: true,
                          fullWidth: false
                        }
                      }, null, 2)
                    }
                  </pre>
                </code>
              </div>
              <div className={"text-2xl font-semibold"}>Response</div>
              <div className={"text-sm bg-gray-200 pl-4 py-4 overflow-scroll max-w-3xl rounded"}>
                <code>
                  <pre>
                    {
                      JSON.stringify({
                        body: "<!DOCTYPE html><html>...</html>",
                        alerts: [],
                        error: null

                      }, null, 2)
                    }
                  </pre>
                </code>
              </div>
            </div>
          </div>

        </div>


      </Box>
      <Footer/>

    </WebsiteLayout>

  </PageHead>

}

export default ApiDoc
